import { SetStateAction, useState } from 'react';
import Image from 'next/image';
interface IProps {
  sortOrder: string;
  setSortOrder: React.Dispatch<React.SetStateAction<string>>;
  sortToggle: boolean;
  setSortToggle: React.Dispatch<SetStateAction<boolean>>;
  currentPage: number;
  setCurrentPage: React.Dispatch<SetStateAction<number>>;
}
const sortObjectKeys: string[] = ['Newest', 'Oldest', 'Highest', 'Lowest'];
const ReviewsSorting = ({
  sortOrder,
  setSortOrder,
  sortToggle,
  setSortToggle,
  currentPage,
  setCurrentPage
}: IProps) => {
  return (
    <div id="sorting by time" className="relative">
      <div>
        <button
          className="mx-auto md:mx-none pl-3 flex px-4 w-[100px] md:w-[180px] xl:w-[200px] justify-between items-center bg-white border-2 rounded-lg h-[42px]"
          onClick={() => setSortToggle(!sortToggle)}
        >
          <span className="text-sm sm:text-[18px] font-[400]">{sortOrder}</span>
          <span className="inline-block pl-2">
            <Image
              src={
                'https://res.cloudinary.com/see-sight-tours/image/upload/v1686742410/Remaining%20images/Reviews/review-filtercitydropdown_mtjjfv.svg'
              }
              width={15}
              height={15}
              alt="dropdown"
            />
          </span>
        </button>
      </div>
      {sortToggle && (
        <div className="absolute top-[100%] w-[100%] z-[60] rounded-b-[5px]">
          {sortObjectKeys?.map((item: string) => (
            <div
              key={item}
              onClick={() => {
                setSortOrder(item);
                setSortToggle(!sortToggle);
                setCurrentPage(0);
              }}
              className={`border-b bg-[#FFFFFF] hover:cursor-pointer px-2 py-2 ${
                item === sortOrder ? 'font-bold' : 'font-normal'
              }`}
            >
              {item}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReviewsSorting;
